import dayjs from 'dayjs/esm/index.js'

export const updateYearQuery = (year: number) => {
  const route = useRoute()
  const router = useRouter()

  if (!year) return
  if (year === dayjs().year()) {
    // Filtered like every other query rewrite: navigating must not carry
    // unknown params forward, or the URL grows a layer per hop.
    const query = filterRouteQuery(route?.query)
    delete query.year
    router.replace({ query })
  } else {
    router.push({
      query: { ...filterRouteQuery(route?.query), year: String(year) }
    })
  }
}
